import { getTaskStatusLabel, isTaskSnoozed } from '@snootsvet/shared'

import { Badge } from '@/frontend/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/frontend/components/ui/card'
import { TaskActions } from '@/frontend/features/tasks/task-actions'
import { getTaskStatusVariant } from '@/frontend/features/tasks/task-utils'
import { useListPatientTasks } from '@/frontend/hooks/api/patients/use-list-patient-tasks'

/** Sidebar card showing open tasks related to this patient. */
export function PatientTasksCard({ patientId }: { patientId: string }) {
  const { data: tasks } = useListPatientTasks(patientId)
  const open = tasks?.filter((t) => t.status === 'open' && !isTaskSnoozed(t)) ?? []
  const snoozedCount = tasks?.filter(isTaskSnoozed).length ?? 0
  const completedCount = (tasks?.length ?? 0) - open.length - snoozedCount

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Tasks
          {open.length > 0 && (
            <Badge variant="secondary" size="sm">
              {open.length}
            </Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {open.length === 0 ? (
          <p className="text-muted-foreground">No open tasks.</p>
        ) : (
          <>
            {open.map((task) => (
              <div key={task.id} className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  {'urgent' in task.data && task.data.urgent && (
                    <Badge variant="destructive">Urgent</Badge>
                  )}
                  <span className="text-sm">{task.title}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Badge variant={getTaskStatusVariant(task)} size="sm">
                    {getTaskStatusLabel(task)}
                  </Badge>
                  <TaskActions task={task} />
                </div>
              </div>
            ))}
            {snoozedCount > 0 && (
              <p className="text-xs text-muted-foreground">
                {snoozedCount} snoozed task(s) (hidden)
              </p>
            )}
            {completedCount > 0 && (
              <p className="text-xs text-muted-foreground">
                {completedCount} completed task(s) (hidden)
              </p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  )
}
